import { render, staticRenderFns } from "./CompactorReport.vue?vue&type=template&id=5b81a13b"
import script from "./CompactorReport.vue?vue&type=script&lang=js"
export * from "./CompactorReport.vue?vue&type=script&lang=js"
import style0 from "./CompactorReport.vue?vue&type=style&index=0&id=5b81a13b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports